import { MessageSquareMore, MessageSquareX, EyeOff, Eye } from 'lucide-react';

export const activationNotificationOptionsRich = [
  {
    label: 'Send',
    value: 'true',
    icon: MessageSquareMore,
    description:
      'Beneficiary representatives receive an email confirming the escrow has been activated. The email does not include details about the deposited assets.',
  },
  {
    label: 'Don’t send',
    value: 'false',
    icon: MessageSquareX,
    description:
      'The beneficiary representatives will not receive an automatic email notifying them of the escrow activation.',
  },
];

export const activationNotificationOptionsRichDictionary = activationNotificationOptionsRich.reduce(
  (acc, { value, label, icon, description }) => ({ ...acc, [value]: { label, icon, description } }),
  {} as Record<string, { label: string; icon: React.ElementType; description: string }>,
);

export const assetVisibilityOptionsRich = [
  {
    label: 'Show assets',
    value: 'true',
    icon: Eye,
    description: 'Beneficiary members can see asset details and can choose their own notification settings.',
  },
  {
    label: 'Hide assets',
    value: 'false',
    icon: EyeOff,
    description:
      'Beneficiaries will only receive an email when the escrow is activated. They won’t see any asset details, and no other notifications will be sent to them automatically.',
  },
];

export const assetVisibilityOptionsRichDictionary = assetVisibilityOptionsRich.reduce(
  (acc, { value, label, icon, description }) => ({ ...acc, [value]: { label, icon, description } }),
  {} as Record<string, { label: string; icon: React.ElementType; description: string }>,
);
